import React from "react";
import DevolutivasDocumentoDialog from "../../../componentes/comuns/DevolutivasDocumentoDialog";

export default function HistoricoRetornosDocumentoDialog(props) {
  return <DevolutivasDocumentoDialog {...props} titulo="Histórico do documento" />;
}
